<template>
	<div id="app">
		<keep-alive>
			<router-view></router-view>
		</keep-alive>
	</div>
</template>

<script>
	export default {
		name: 'App',
		components: {

		}
	}
</script>

<style>
	.loading {
		display: flex;
		justify-content: center;
		margin: 0 0 30px 0;
		align-items: center;
	
		.loadingIcon {
			margin-right: 10px;
		}
	
		.noData {
			font-size: 32px;
			color: #828282;
		}
	}
</style>
